export default {"src":"/_next/static/media/dark-purple-right-inverted.7f831f96.svg","height":280,"width":1920,"blurWidth":0,"blurHeight":0};